import {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {requestJobs} from "../../../redux/Actions/jobs.action";
import {
  getJobsList,
  getJobsPaginationUrls,
  getTotalCount,
} from "../../../redux/Selectors/jobs.selector";

export const useJobsTableData = () => {
  const dispatch = useDispatch();
  const jobs = useSelector(getJobsList);
  const jobUrls = useSelector(getJobsPaginationUrls);
  const totalCount = useSelector(getTotalCount);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    dispatch(requestJobs());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handlePagination = (page) => {
    const url = currentPage < page ? jobUrls?.nextUrl : jobUrls?.prevUrl;
    dispatch(requestJobs(url));
    setCurrentPage(page);
  };

  const paginationConfig = {
    currentPage,
    onPageChange: handlePagination,
  };

  return {jobs, paginationConfig, totalCount};
};
